import Vue from 'vue';

import App from './App.vue';
import router from './router';

import apolloProvider from '@/apollo';
import { apolloClient } from '@/apollo';

import Notification from 'vue-notification';

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog, faQuestion, faEdit, faPlus, faMinus, faTrashAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import store from './store';
import { QueryOptions, MutationOptions } from 'apollo-boost';
import authenticationService from './services/authentication.service';
// tslint:disable-next-line:no-var-requires
const VueTreeNavigation = require('vue-tree-navigation');

// tslint:disable-next-line:no-var-requires
const vueMoment = require('vue-moment');

library.add(faCog, faQuestion, faEdit, faPlus, faMinus, faTrashAlt, faUser);

Vue.use(VueTreeNavigation);
Vue.use(BootstrapVue);
Vue.use(vueMoment);
Vue.use(Notification);
Vue.component('v-select', vSelect);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.prototype.$query = (options: QueryOptions) => apolloClient.query(options);
Vue.prototype.$mutation = (options: MutationOptions) => apolloClient.mutate(options);
Vue.prototype.$isAdmin = authenticationService.isAdmin.bind(authenticationService);
Vue.prototype.$isHr = authenticationService.isHr.bind(authenticationService);
Vue.prototype.$is = authenticationService.is.bind(authenticationService);
Vue.prototype.$isLoggedUser = authenticationService.isLoggedUser.bind(authenticationService);
Vue.prototype.$notify = ({
  group = 'main',
  type = '',
  title = 'Tytuł',
  text = 'Tekst',
  duration = 3000,
  speed = 500
} = {}) => {
  /**
   * Type default - blue
   *      success - green
   *      warn    - orange/yellow
   *      error   - red
   */
  Vue.notify({ group, type, title, text, duration, speed });
};
Vue.config.productionTip = false;

export const app = new Vue({
  apolloProvider,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
